export enum ENmWebsTypes {
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  AIRLINE = 'AIRLINE',
  CAMPAIGN = 'CAMPAIGN',
  HOME = 'HOME',
}

export enum ENmWebElementTypes {
  ELEMENT_IMAGE = 'TYPIMG',
  ELEMENT_TITLE = 'TITLE',
  ELEMENT_BODY = 'BODY',
  ELEMENT_LINK = 'LINK',
  // ELEMENT_SUB_TITLE = 'SUB_TITLE',
  ELEMENT_LOGO = 'LOGO',
  ELEMENT_ALT = 'ALT',
  ELEMENT_TAB = 'TAB',
  ELEMENT_TEXT = 'TEXT',
}

export enum ENmWebSectionTypes {
  SECTION_BANNER_TOP = 'BANSEC',
  SECTION_BANNER_PROM = 'PROMBAN',
  SECTION_DESCRIPTION = 'DESCRI',
  SECTION_FAQ = 'FAQ',
  SECTION_POPULAR_ROUTES = 'POPROUTES',
  // SECTION_TITLE_CARD = 'TITLE_CARD',
  SECTION_CARD = 'CARD',
  SECTION_CARD_INT = 'CARD_INT',
  SECTION_SEARCHBAN = 'SEARCHBAN',
  SECTION_SCHBAN_MOBILE = 'SRCHB_MOB',
  SECTION_CARD_DETAIL = 'CARD_DET',
  SECTION_HOME_TABS = 'TABS',
  SECTION_LINKS = 'LINKS_SEC',
  SECTION_LINK_LIST = 'LINK_LIST',
}
